import { useParams } from 'react-router-dom'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import SellInvoiceCreateNoPermissionStep from './Steps/SellInvoiceCreateNoPermissionStep'
import SellInvoiceCreateStep from './Steps/SellInvoiceCreateStep'
import SellInvoiceFinishedStep from './Steps/SellInvoiceFinishedStep'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { WorkSheetGroupStatusesPayload } from '../../../../../../../../utils/reducers/sells/workSheetGroupStatus'


interface SingleSellInvoiceProps extends TableComponentProps { }

const SingleSellInvoice: React.FC<SingleSellInvoiceProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/sell/sellInvoice/orderProduct/createSellInvoiceProduct', { OrderId }],
        getData: ['/api/app/order/sell/sellInvoice/getSellInvoiceComplete', { id: OrderId }],
        updateData: '/api/app/order/sell/sellInvoice/orderProduct/updateSellInvoiceProduct',
        delete: '/api/app/order/sell/sellInvoice/orderProduct/deleteSellInvoiceProduct',
        updateHeaderData: '/api/app/order/sell/sellInvoice/updateSellInvoice',
        getSubProducts: ['/api/app/order/sell/sellInvoice/orderProduct/getAllSubSellInvoiceProducts', ['CustomerId']],
        updateOrderLines: '/api/app/order/sell/sellInvoice/updateSellInvoiceNLines',
        printTags: '/api/app/order/sell/sellInvoice/printSellInvoiceTags'
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'sell.invoice' })
    const status = parseInt(completeData?.header.status)
    if (!permissionCheck(getUserPermissions('sell.invoice'), 'update') || completeData?.header.hidePrices || completeData?.header.notModificable) {
        return <SellInvoiceCreateNoPermissionStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === sellInvoiceStatusInversed['accepted'] || status === sellInvoiceStatusInversed['refunded']) {
        return <SellInvoiceFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return <SellInvoiceCreateStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
}

const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(SingleSellInvoice, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const SingleSellInvoiceConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)

export default SingleSellInvoiceConnect